import { render, staticRenderFns } from "./RequestLifecycle.vue?vue&type=template&id=bc744a54&scoped=true"
import script from "./RequestLifecycle.vue?vue&type=script&lang=js"
export * from "./RequestLifecycle.vue?vue&type=script&lang=js"
import style0 from "./RequestLifecycle.vue?vue&type=style&index=0&id=bc744a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc744a54",
  null
  
)

export default component.exports